import { useEffect } from "react";
import { useAuth } from "../auth/AuthProvider";
import { identifyUser, resetUser, whenPostHogReady } from "./posthog";

/**
 * Syncs PostHog identity with the current auth state.
 *
 * Mount inside AuthProvider so it can read useAuth(). Renders nothing — it
 * exists purely for the side-effect of calling identify/reset when the user
 * changes.
 *
 * The effect awaits whenPostHogReady() because init loads posthog-js via a
 * dynamic import. Portal users typically land already authenticated (session
 * cookie), so the auth check usually resolves before posthog-js finishes
 * loading — without the await, that first identify would silently no-op and
 * never re-fire.
 */
export function PostHogIdentify() {
  const { user } = useAuth();

  useEffect(() => {
    let cancelled = false;

    whenPostHogReady().then(() => {
      if (cancelled) return;
      if (user) {
        identifyUser(user);
      } else {
        resetUser();
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return null;
}
